module.exports = new __parcel__URL__("progress-default.d37985df.svg").toString();